import script from "./ClicksByReferrer.vue?vue&type=script&setup=true&lang=js"
export * from "./ClicksByReferrer.vue?vue&type=script&setup=true&lang=js"

import "./ClicksByReferrer.vue?vue&type=style&index=0&id=48436f10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48436f10"]])

export default __exports__